<div class="modal-header">
  <h5 class="modal-title">Suscripción vencida</h5>
  <button type="button" class="close" aria-label="Close" (click)="cerrar()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p *ngIf="expiresAt">Tu suscripción venció el {{formattedDate}}.</p>
  <p *ngIf="!expiresAt">Tu suscripción venció.</p>
  <p class="text-muted small">Renueva tu suscripción para continuar usando el servicio.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cerrar()">Cerrar</button>
  <button type="button" class="btn btn-primary" (click)="renovar()">Renovar suscripción</button>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/subscription-expired-modal/subscription-expired-modal.component.html